import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useCustomer } from "../context/CustomerContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AccountAuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setCustomer } = useCustomer();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(location.hash.replace("#", ""));
    const sessionId = params.get("session_id");
    if (!sessionId) { navigate("/account/login", { replace: true }); return; }
    api.post("/account/google/session", { session_id: sessionId })
      .then((r) => {
        setCustomer(r.data);
        window.history.replaceState(null, "", "/account");
        navigate("/account", { replace: true, state: { user: r.data } });
      })
      .catch(() => navigate("/account/login", { replace: true }));
  }, [location.hash, navigate, setCustomer]);

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center">
      <p className="font-serif-display uppercase tracking-[0.2em] text-plum-deep/60">SIGNING YOU IN…</p>
    </div>
  );
};

export default AccountAuthCallback;
